ScoreTrekBattle.Settings.Tables = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            active: false,
            $view: null,
            $list: null,
            scoreboards: []
        };
    }
    resetStatus();

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu(`/settings`);
            ScoreTrekBattle.Template.render('settings/tables/list').then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');
                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            updateList();
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }
                updateList();
            }, 0);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function loadTables() {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tables').then(result => {
                resolve(result.list);
            }).catch(reject);
        });
    }

    function loadScoreboards() {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/scoreboards').then(result => {
                resolve(result.list);
            }).catch(reject);
        });
    }

    function updateList() {
        ScoreTrekBattle.View.loading('Settings.Tables.updateList', true);
        Promise.all([
            loadTables(),
            loadScoreboards()
        ]).then(lists => {
            STATUS.scoreboards = lists[1];
            renderTables(lists[0]);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.Tables.updateList', false);
        });
    }

    function renderTables(tables) {
        return new Promise(function(resolve, reject) {
            var promises;
            promises = [];
            tables.forEach(table => {
                promises.push(renderTable(table));
            });
            STATUS.$list.empty();
            Promise.all(promises).then($tables => {
                STATUS.$list.append($tables);
                resolve();
            }).catch(reject);
        });
        
    }

    function renderTable(table) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render('settings/tables/item', {table: table}).then(view => {
                var options, currentData, loadedData, $element;

                function checkModified() {
                    var isModified;
                    isModified = (loadedData.id === '');
                    Object.keys(currentData).forEach(key => {
                        isModified = isModified || (currentData[key] !== loadedData[key]);
                    });
                    $element.modified.css('display', isModified ? '' : 'none');
                    $element.save.prop('disabled', !isModified);
                }

                function silentSave() {
                    updateTable(currentData).then(tableData => {
                        currentData.id = tableData.id;
                        loadedData = DataHandler.cloneObject(currentData);
                    }).catch(error => {
                        chmDialog.error(error);
                    }).finally(() => {
                        checkModified();
                    });
                }

                loadedData = {
                    id: table.id,
                    name: table.name,
                    type: table.type,
                    isActive: table.isActive,
                    scoreboardId: table.scoreboardId
                };

                currentData = DataHandler.cloneObject(loadedData);

                $element = {
                    save: view.$view.find('[data-id="save"]'),
                    modified: view.$view.find('[data-id="modified"]'),
                    rename: view.$view.find('[data-id="rename"]'),
                    delete: view.$view.find('[data-id="delete"]'),
                    name: view.$view.find('[data-id="tableName"]')
                };

                $element.save.on('click', function() {
                    ScoreTrekBattle.View.loading('Settings.Tables.save', true);
                    updateTable(currentData).then(tableData => {
                        currentData.id = tableData.id;
                        loadedData = DataHandler.cloneObject(currentData);
                        checkModified();
                    }).catch(error => {
                        chmDialog.error(error);
                    }).finally(() => {
                        ScoreTrekBattle.View.loading('Settings.Tables.save', false);
                    });
                });

                $element.rename.add($element.name).on('click', function() {
                    editTableName(currentData.name).then(tableName => {
                        currentData.name = tableName;
                        $element.name.text(tableName);
                        silentSave();
                    }).catch(ignore => {})
                });

                $element.delete.on('click', function() {
                    confirmDeleteTable(currentData.id, currentData.name).then(deleted => {
                        if (!deleted) {
                            return;
                        }
                        view.$view.slideUp(function() {
                            view.$view.remove();
                        });
                    }).catch(error => {
                        chmDialog.error(error);
                    });
                });

                view.controls.isActive.set(table.isActive);
                view.controls.isActive.on('change', function() {
                    currentData.isActive = this.get();
                    silentSave();
                });

                options = DataHandler.arrayToOptions(STATUS.scoreboards, 'id', 'name');
                view.controls.scoreboardId.setOptions(options, {'': `- ${__i18n('table/scoreboard/none')} -`});
                view.controls.scoreboardId.set(table.scoreboardId);
                view.controls.scoreboardId.on('change', function() {
                    currentData.scoreboardId = this.get();
                    silentSave();
                });

                view.controls.tableType.set(table.type);
                view.controls.tableType.on('change', function() {
                    currentData.type = this.get();
                    silentSave();
                });

                checkModified();

                resolve(view.$view);
            }).catch(reject);
        });
    }

    function editTableName(currentTableName) {
        return new Promise(function(resolve, reject) {
            chmDialog.prompt({
                title: __i18n('dialog/table/name/title'),
                prompt: __i18n('dialog/table/name/prompt'),
                value: currentTableName
            }).then(tableName => {
                if (!tableName) {
                    reject();
                    return;
                }
                resolve(tableName);
            }).catch(reject);
        });
    }

    function updateTable(tableData) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Settings.Tables.updateTable', true);
            Api.request('/battle/table/update', tableData).then(result => {
                resolve(result.table);
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Settings.Tables.updateTable', false);
            });
        });
    }

    function confirmDeleteTable(tableId, tableName) {
        return new Promise(function(resolve, reject) {
            chmDialog.confirm(__i18n('dialog/confirm/delete/text', {colorClass: 'color-blue', reference: tableName}, true), {
                title: __i18n('dialog/confirm/delete/title'),
                buttonYes: __i18n('button/delete'),
                buttonNo: __i18n('button/cancel')
            }).then(() => {
                if (tableId === '') {
                    resolve(true);
                    return;
                }
                ScoreTrekBattle.View.loading('Settings.Tables.delete', true);
                deleteTable(tableId).then(() => {
                    resolve(true);
                }).catch(reject).finally(() => {
                    ScoreTrekBattle.View.loading('Settings.Tables.delete', false);
                });
            }).catch(() => {
                resolve(false);
            });
        });
    }

    function deleteTable(tableId) {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/table/delete', {id: tableId}).then(result => {
                resolve();
            }).catch(reject);
        });
    }

    function getNewTableName() {
        let tableNumber;

        if (!STATUS.$list) {
            tableNumber = '01';
        } else {
            tableNumber = (STATUS.$list.children().length + 1);
            tableNumber = `${(tableNumber < 10) ? '0' : ''}${tableNumber}`;
        }

        return __i18n('table/new', {number: tableNumber});
    }

    _this = {
    };

    ScoreTrekBattle.View.register('/settings/tables', () => { return onViewRender(); }, onViewLoad, onViewUpdate, onViewUnload);

    ScoreTrekBattle.Event.on('action.table.add', function() {
        if (!STATUS.active) {
            return;
        }

        editTableName(getNewTableName()).then(tableName => {
            renderTable({
                id: '',
                name: tableName,
                isActive: true,
                scoreboardId: ''
            }).then($table => {
                // $table.hide();
                STATUS.$list.prepend($table);
                // $table.slideDown();
            });
        }).catch(ignore => {});
    });

    return _this;
})();